module.exports = __webpack_public_path__ + "img/16k006-10.b6080566.png";